import { lazy } from 'react';

/** Authorized Pages */

export const Ingestion = lazy(() => import('./Authorized/Pipelines'));
export const NewPipeline = lazy(() =>
  import('./Authorized/Pipelines/NewPipeline')
);
export const PipelineDetails = lazy(() =>
  import('./Authorized/Pipelines/PipelineDetails')
);
export const SDIPipeline = lazy(() => import('./Authorized/SDIPipelines'));
export const SDINewPipeline = lazy(() =>
  import('./Authorized/SDIPipelines/NewSDIPipeline')
);
export const SDIPipelineDetails = lazy(() =>
  import('./Authorized/SDIPipelines/SDIPipelineDetails')
);

export const Visualization = lazy(() => import('./Authorized/Visualization'));
export const Catalog = lazy(() => import('./Authorized/Catalog'));
export const ManageUsers = lazy(() => import('./Authorized/Management/Users'));
export const Infrastructure = lazy(() => import('./Authorized/Infrastructure'));
export const Sandbox = lazy(() => import('./Authorized/Sandbox'));
export const Addons = lazy(() => import('./Authorized/Addons'));
export const Home = lazy(() => import('./Authorized/Home'));
export const Exports = lazy(() => import('./Authorized/Exports'));
export const Marketplace = lazy(() => import('./Authorized/Marketplace'));
export const Support = lazy(() => import('./Authorized/Support'));
export const MarketplaceDetails = lazy(() =>
  import('./Authorized/Marketplace/MarketplaceDetails')
);
export const Jobs = lazy(() => import('./Authorized/Jobs/index'));
export const JobContainer = lazy(() =>
  import('./Authorized/Jobs/container-controller')
);
/** Unauthorized Pages */
export const Login = lazy(() => import('./Unauthorized/Login'));
export const Register = lazy(() => import('./Unauthorized/Register'));
export const Callback = lazy(() => import('./Unauthorized/Callback'));
export const Invite = lazy(() => import('./Unauthorized/Invite'));
export const Chat2Dash = lazy(() => import('./Authorized/Chat2Dash'));
